/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_No_Event_GroupsInputs */

const en_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No eligible Event Groups available.`)
};

const fr_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun groupe d'événements éligible disponible.`)
};

const de_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine geeigneten Ereignisgruppen verfügbar.`)
};

const it_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun gruppo eventi idoneo disponibile.`)
};

const ru_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет подходящих групп событий.`)
};

const es_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay grupos de eventos elegibles disponibles.`)
};

const zh_cn2_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有可用的事件组。`)
};

const ja_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象となるイベントグループがありません。`)
};

const hi_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई उपयुक्त इवेंट समूह उपलब्ध नहीं है।`)
};

const pt_pt2_offline_sync_no_event_groups = /** @type {(inputs: Offline_Sync_No_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não existem grupos de eventos elegíveis.`)
};

/**
* | output |
* | --- |
* | "No eligible Event Groups available." |
*
* @param {Offline_Sync_No_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_no_event_groups = /** @type {((inputs?: Offline_Sync_No_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_No_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_no_event_groups(inputs)
	if (locale === "de") return de_offline_sync_no_event_groups(inputs)
	if (locale === "it") return it_offline_sync_no_event_groups(inputs)
	if (locale === "ru") return ru_offline_sync_no_event_groups(inputs)
	if (locale === "es") return es_offline_sync_no_event_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_no_event_groups(inputs)
	if (locale === "ja") return ja_offline_sync_no_event_groups(inputs)
	if (locale === "hi") return hi_offline_sync_no_event_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_no_event_groups(inputs)
	return en_offline_sync_no_event_groups(inputs)
});